<template>
    <div v-if="!isBaseExExist" style="display: flex;flex-direction: column;align-items: center;">
        <n-alert  type="info" style="margin-bottom: 20px;">
            {{ $t('coupons_text8') }}
        </n-alert>
        <base-ex ref="baseEXE" style="width: 311px;"></base-ex>
        <n-button type="info" @click="validForm()" :disabled="!isFormFinsh">{{ $t('exgInvCode_text8') }}</n-button>
    </div>
    <div v-else class="exgInvCode">
        <div v-if="isSuccess" class="exgBox">
            <h2 class="exgBox-title">{{ $t('exgInvCode_text1') }}</h2>
            <h1 class="exgBox-subTitle">
                {{$t('exgInvCode_text2')}}
            </h1>
            <img class="exgBox-logo" :src="logoSrc"/>
            <div class="exgBox-cont">{{ $t('exgInvCode_text3') }}</div>
            <template v-if="irsInfo">
                <div class="exgBox-dateTitle">
                    <span v-html="$t('exgInvCode_text4')"></span>
                    <span class="exgBox-dateTime">
                        <b>{{ dateFormat(irsInfo.exp) }}</b>
                    </span>
                </div>
            </template>
        </div>
        <div v-if="isError" class="exgBox errBox">
            <n-icon :component="WarningOutline" size="80" style="margin-bottom: 7px;"/>
            <h2 class="exgBox-title exgBox-error">{{ $t('exgInvCode_text5') }}</h2>
            <h1 class="exgBox-subTitle exgBox-error">{{ $t('exgInvCode_text6') }}</h1>
            <div style="margin: 115px 0 50px 0;font-size: 16px;padding: 0 8px;" v-html="$t('exgInvCode_text7')"></div>
        </div>
    </div>
</template>
<script>
import { jsFn } from "@/utils/jsFn";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { defineComponent, ref, inject, computed, onMounted} from 'vue'
import { useI18n } from "vue-i18n";
import baseex from '@/components/baseEX.vue'
import { WarningOutline } from '@vicons/ionicons5'

export default defineComponent({
    components: {
        'base-ex': baseex
    },
    setup() {
        const i18n = useI18n();
        const isSuccess = ref(false)
        const isError = ref(false)
        const store = useStore();
        const irsInfo = computed(() => store.getters['coreApi/getBenifitsFunc']('hiteach', 'webirs'))
        const baseEx = computed(() => store.getters['coreApi/baseEx']);
        const baseEXCheckKey = computed(() => store.getters["coreApi/baseEXCheckKey"]);
        const changeSpinState = inject('changeSpinState')
        const router = useRouter();
        const route = useRoute();
        var logoSrc = require('@/assets/img/teammodelmail.png')
        var lang = route.params.lang
        const referralCode = route.params.referralCode
        const code = route.query.code
        const baseEXE = ref()
        const isBaseExExist = ref(true)

        // 設定頁面的語系
        i18n.locale.value = lang;
        localStorage.setItem("lang", lang);

        onMounted(async() => {
            if (!jsFn.IsEmpty(code) && !jsFn.IsEmpty(referralCode)) {
                changeSpinState()  // open spin

                // 先重置
                await store.dispatch("coreApi/resetState")

                await store.dispatch("coreApi/codeLogin", code).then(async()=>{
                    //取得個人在base-ex的設定檔
                    await store.dispatch("coreApi/getUsersetting", 'base-ex')
                    
                    // 判斷是否有填寫進階資訊
                    if(baseEx.value){
                        baseEXCheckKey.value.forEach(c=>{
                            switch(c){
                                case 'country':{
                                        let pattern_En = new RegExp("[A-Za-z]")
                                        if (!pattern_En.test(baseEx.value[c])) {
                                            isBaseExExist.value = false
                                        }
                                    }
                                    break
                                case 'schoolCode':
                                // 暫不檢查
                                //     if(baseEx.value['country'] == 'TW' && (baseEx.value[c] == '' || baseEx.value[c] == null)){
                                //         isExist = false
                                //     }
                                break
                                default:
                                    if(baseEx.value[c] == '' || baseEx.value[c] == null) {
                                        isBaseExExist.value = false
                                    }
                            }
                        })
                    } else {
                        isBaseExExist.value = false
                    }
                    

                }).catch(()=>{
                    router.push({ name: 'errorLogin', params: { lang: lang } });
                }).finally(()=>{
                    changeSpinState()  // close spin 
                })

                if(isBaseExExist.value){
                    exgInvCode()
                }
            } else {
                router.push({ name: 'errorLogin', params: { lang: lang } });
            }
        })

        async function exgInvCode(){
            changeSpinState()  // open spin
            await store.dispatch("coreApi/applyReferralCode", referralCode).then(async()=>{
                // 兌換成功
                isSuccess.value = true
                // 取得個人額外活動資訊
                await store.dispatch("coreApi/getUsersetting", 'benefits')
            }).catch(()=>{
                isError.value = true
            }).finally(()=>{
                changeSpinState()  // close spin 
            })
        }

        const validForm = ()=>{
            baseEXE.value.baseExFormRef.validate(
                async(errors) => {
                    if (!errors) {
                        changeSpinState() // 開啟全屏spin
                        let data = {}
                        if(baseEx.value){
                            let bKeys = Object.keys(baseEx.value)

                            bKeys.forEach(k=>{
                                if(baseEXE.value.baseExValue[k]) {
                                    data[k] = baseEXE.value.baseExValue[k]
                                } else {
                                    data[k] = baseEx.value[k]
                                }
                            })
                        } else {
                            data = baseEXE.value.baseExValue
                        }

                        // 寫入baseEX
                        await store.dispatch('coreApi/setUserContact', data).then(() => {
                            changeSpinState() // 關閉全屏spin
                            isBaseExExist.value = true
                            exgInvCode()
                        }).catch(e =>{
                            console.log(e)
                        })
                    }
                }
            )
        }

        const dateFormat = (val)=>{
            let time = val
            if(val.toString().length < 13) {
                time = time * 1000
            }

            return new Date(parseInt(time)).toISOString().split('T')[0].replaceAll('-', '/')
        }

        // 設定都完成按鈕亮燈
        const isFormFinsh = computed(()=>{
            let flag = true
            baseEXCheckKey.value.forEach(c=>{
                switch(c){
                    case 'schoolCode':
                        // 暫不檢查
                        // if(baseEXE.value?.baseExValue['country'] == 'TW' && (baseEXE.value?.baseExValue[c] == '' || baseEXE.value?.baseExValue[c] == null)){
                        //     flag = false
                        // }
                    break
                    default:
                        if(baseEXE.value?.baseExValue[c] == '' || baseEXE.value?.baseExValue[c] == null) {
                            flag = false
                        }
                }
            })
            return flag
        })
            
        return {
            logoSrc,
            isSuccess,
            isError,
            irsInfo,
            dateFormat,
            validForm,
            isBaseExExist,
            baseEXE,
            isFormFinsh,
            WarningOutline
        }
    }
})
</script>
<style lang="less" scoped>
.exgInvCode{
    padding: 10px 17px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 94vh;
    .exgBox{
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        border: 1px solid #737373;
        padding: 7px;
        border-radius: 20px;
        &.errBox{
            border: none;
        }
        &-title{
            color: #00bcd4;
            margin: 0;
        }
        &-subTitle{
            margin-bottom: 0px;
            color: #00bcd4;
            margin-top: 0;
            text-align: center;
        }
        &-error{
            color: #ffb74d;
        }
        &-logo{
            display: block;
            width: 120px;
            height: 120px;
        }
        &-cont{
            text-align: center;
            margin: 7px 0 50px 0;
            font-size: 15px;
            padding: 0 8px;
        }
        &-dateTitle{
            width: 250px;
            text-align: center;
        }
        &-dateTime{
            b{
                font-size: 17px;color: #00bcd4;
            }
        }
    }
}
</style>